import { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Custom hook to fetch dynamic exam types from the backend.
 * Returns the list of active exam types for use in dropdowns/autocomplete.
 */
export const useExamTypes = (token) => {
  const [examTypes, setExamTypes] = useState([]);
  const [examTypeNames, setExamTypeNames] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchExamTypes = async () => {
      if (!token) {
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get(`${API_URL}/api/exam-types/names`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const data = response.data || [];
        setExamTypes(data);
        // Extract just the names for simple dropdowns/datalists
        setExamTypeNames(data.map(e => e.name));
        setError(null);
      } catch (err) {
        console.error('Error fetching exam types:', err);
        setError(err.message);
        // Fallback to empty array
        setExamTypes([]);
        setExamTypeNames([]);
      } finally {
        setLoading(false);
      }
    };

    fetchExamTypes();
  }, [token]);

  const refetch = async () => {
    if (!token) return;
    
    setLoading(true);
    try {
      const response = await axios.get(`${API_URL}/api/exam-types/names`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = response.data || [];
      setExamTypes(data);
      setExamTypeNames(data.map(e => e.name));
      setError(null);
    } catch (err) {
      console.error('Error refetching exam types:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return { 
    examTypes,         // Full objects with name, default_price, default_duration
    examTypeNames,     // Just the names array for simple lists
    loading, 
    error,
    refetch 
  };
};

export default useExamTypes;
